module.exports = __webpack_public_path__ + "images/application/switch-guide-blue-d973db0e.png";